import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { Link } from "react-router-dom";

export default function Deals() {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const response = await axios.get("/deals"); // Fetch all deals
        setDeals(response.data);
        console.log("Deals fetched successfully:", response.data);
      } catch (error) {
        console.error("Error fetching deals:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDeals();
  }, []);

  if (loading) return <p className="text-center mt-5">Loading deals...</p>;

  return (
    <div className="container mt-4">
      <h2 className="mb-4">🔥 Best Deals</h2>

      {deals.length === 0 ? (
        <p className="text-center text-muted">No deals available right now.</p>
      ) : (
        <div className="row">
          {deals.map((product) => (
            <div className="col-md-3 mb-4" key={product.product_id}>
              <div className="card h-100 shadow-sm">
                <img
                  src={product.product.image_url}
                  className="card-img-top"
                  alt={product.product.name}
                  style={{ height: "200px", objectFit: "cover" }}
                />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{product.product.name}</h5>
                  <p className="card-text text-muted">
                    {product.value > 0 ? (
                      <>
                        <span className="text-decoration-line-through me-2">
                          ₹{product.product.price}
                        </span>
                        <span className="text-success fw-bold">
                          ₹{product.product.price - product.value}
                        </span>
                      </>
                    ) : (
                      <>₹{product.product.price}</>
                    )}
                  </p>
                  <Link
                    to={`/product/${product.product_id}`}
                    className="btn btn-primary mt-auto"
                  >
                    View Deal
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
